<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="consts.meetingType.florist">
      <BOverlay :show="overlayShow" rounded="sm">
        <div class="base-color h-100 mh-515 shadow">
          <div class="content-container">
            <div class="content-wrapper">
              <div class="left-content">
                <h5 class="text-primary ps-3 pt-2 mb-2">{{agendaData('title')}}</h5>
                <ul class="list-group mb-3">
                  <li class="list-group-item border-0" v-for="(content, index) in agendaData('contents')" :key="index">・{{content}}</li>
                </ul>
              </div>
              <div class="right-content">
                <img class="agenda-image" :src="imageUrl" alt="Agenda Image">
              </div>
            </div>
            <div class="button-area">
              <BButton variant="outline-primary" class="btn-action sub-button-color" @click="reload" id="reload">更新</BButton>
              <BButton variant="primary" class="btn-action main-button-color" :disabled="isLoading" @click="nextPage" id="next">次へ</BButton>
            </div>
          </div>
        </div>
      </BOverlay>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import AgendaModel from '@/models/AgendaModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import fstore from '@/store/florist-store'
import mstore from '@/store/meeting-store'
// import { useModal } from 'bootstrap-vue-next'

export default {
  name: 'FloristMeetingAgenda',
  components: { CommonLayout, MeetingLayout, CommonModal },
  /* setup () {
    const modal = useModal()
    return { modal }
  }, */
  data () {
    return {
      overlayShow: false,
      isSendFirstSignalingData: false,
      isCustomerRegistered: false,
      isLoading: true,
      imageUrl: ''
    }
  },
  computed: {
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    getIsTargetAtendeeActive () {
      return mstore.getters.isTargetAtendeeActive
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$refs.commonModal, newData, () => {
        })
        if (newData['event'] === 'status') {
          if (newData['data']['show_agenda_view'] === 'success') {
            this.sendSignalingApiData()
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  methods: {
    agendaData (key) {
      try {
        const store = AgendaModel.getStore()
        if (!store) {
          return null
        }
        return store.agenda[key]
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    setApiData: async function (isReload = false) {
      try {
        this.overlayShow = true
        const resData = await AgendaModel.apiSetStore(this.$refs.commonModal, () => {
          this.overlayShow = false
        })
        this.isCustomerRegistered = resData.isCustomerRegistered

        if ((!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) || isReload) {
          this.sendSignalingApiData()
          this.isSendFirstSignalingData = true
        }
        this.isLoading = false
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingApiData () {
      try {
        const store = AgendaModel.getStore()
        if (!store) {
          return null
        }
        let apiRes = {}
        apiRes = {
          'status': store.status,
          'message': store.message,
          'agenda': store.agenda
        }
        SignalingModel.sendApiEvent('getAgenda', this, apiRes)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    nextPage: async function () {
      try {
        let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
        const targetPath = this.isCustomerRegistered ? '/florist/meeting/hearing' : '/florist/meeting/input'
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    reload () {
      try {
        SignalingModel.sendClickEvent('reload', this)
        this.setApiData(true)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  mounted () {
    this.setApiData()
    this.imageUrl = this.config.imageURL + '/meeting-contents/agenda.jpg'
  },
  beforeUnmount () {
    if (AgendaModel.getStore()) {
      AgendaModel.removeStore()
    }
  }
}
</script>
<style scoped>
/* 親要素を100%の高さで確保 */
.content-container {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* コンテンツラッパー - 高さを最大限確保 */
.content-wrapper {
  display: flex;
  flex: 1; /* 残りのスペースを全て使用 */
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

/* 左側コンテンツ */
.left-content {
  width: 58.333333%; /* col-7相当 */
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.left-content h5 {
  margin: 0;
  padding: 2rem 1rem 0.5rem 2rem !important;
  font-size: 1.5rem;
}

.left-content .list-group {
  padding-left: 1rem;
  padding-right: 0.5rem;
  margin-bottom: 0 !important;
}

/* 右側コンテンツ - 画像エリア */
.right-content {
  width: 41.666667%; /* col-5相当 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
}

.agenda-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* ボタンエリア */
.button-area {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  left: auto;
  text-align: right;
  z-index: 10;
}

.btn-action {
  min-width: 100px;
  margin-left: 0.75rem;
}

.btn-action:first-child {
  margin-left: 0;
}
</style>
